import React, { FormEvent } from 'react';
import { useField, useFormikContext } from 'formik';
import CustomInput from './CustomInput';
import Label from '../FieldLabel'
import { IInputProps } from './types';
import {
  ErrorMessage,
  InputContainer,
} from '../../../styles/inputs';

const Input: React.FC<IInputProps> = (props: IInputProps) => {
  const {
    type,
    placeholder,
    onFocus,
    name,
    label,
    onBlur,
    mask,
    required,
    disabled,
    value,
    prefix,
    onChange,
    defaultValue,
  } = props;
  const [field, meta, helpers] = useField(props);
  const formikContext = useFormikContext();

  const onFieldChange = (e: FormEvent<HTMLInputElement>) => {
    helpers.setValue(e.currentTarget.value);
  };

  return (
    <InputContainer>
      {!!label && (
        <Label
          htmlFor={name}
          text={label}
          required={required}
        />
      )}
      <CustomInput
        type={type}
        name={name}
        placeholder={placeholder}
        value={field.value || value}
        onChange={onChange ?? onFieldChange}
        onBlur={onBlur ?? field.onBlur}
        onFocus={onFocus ?? formikContext.handleBlur}
        mask={mask ?? ''}
        disabled={disabled}
        prefix={prefix}
        defaultValue={defaultValue}
      />
      {meta.error && (
        <ErrorMessage>
          {meta.error}
        </ErrorMessage>
      )}
    </InputContainer>
  );
};

Input.defaultProps = {
  placeholder: '',
};

export default Input;
